export const en = {
    'loading-text': 'Loading...'
};
